'use client';

import { useState } from 'react';
import type { Reviews } from '@shared/types';

// Интерфейс для пагинации с сервера
export interface PaginationInfo {
  current_page: number;
  total_pages: number;
  total_items: number;
  items_per_page: number;
  has_next: boolean;
  has_prev: boolean;
}

export function useReviewsPagination(reviews: Reviews, pager?: { pages_all: number; records_all: number; records_per_page: number }) {
  const [currentPage, setCurrentPage] = useState(1);

  // Используем pager данные если есть, иначе простая пагинация
  const totalPages = pager?.pages_all || Math.ceil(reviews.length / 5);
  const shouldShowPagination = totalPages > 1;

  // Для серверной пагинации мы не нарезаем данные локально
  // Данные уже приходят пагинированными с сервера
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  // Сброс на первую страницу (например, после добавления нового отзыва)
  const resetToFirstPage = () => {
    setCurrentPage(1);
  };

  return {
    currentPage,
    setCurrentPage: handlePageChange,
    resetToFirstPage,
    paginatedReviews: reviews,
    totalPages,
    shouldShowPagination,
  };
} 